module.exports = __webpack_public_path__ + "img/profile-silver.bb8ed509.svg";